
const newModel = () => {
    return {
        cosoYteTunhanId: null,
        ten: null,
        chuCoSo: null,
        gioiTinh: null,
        namSinh: null,
        trinhdochuyenmonYId: null,
        tenTrinhdochuyenmonY: null,
        tenChuyenkhoaY: null,
        chuyenkhoaYId: null,
        trinhDoChuyenMonKhac: null,
        phuongXaId: null,
        tenPhuongXa: null,
        diaChi: null,
        loaihinhHanhngheYId: null,
        tenLoaihinhHanhngheY: null,
        soCchn: null,
        ngayCapCchn: null,
        soGphd: null,
        ngayCapGphd: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        cosoYteTunhanId: null,
        ten: null,
        chuCoSo: null,
        gioiTinh: null,
        namSinh: null,
        trinhdochuyenmonYId: null,
        tenTrinhdochuyenmonY: null,
        tenChuyenkhoaY: null,
        chuyenkhoaYId: null,
        trinhDoChuyenMonKhac: null,
        phuongXaId: null,
        tenPhuongXa: null,
        diaChi: null,
        loaihinhHanhngheYId: null,
        tenLoaihinhHanhngheY: null,
        soCchn: null,
        ngayCapCchn: null,
        soGphd: null,
        ngayCapGphd: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: "0",
        enabled: true
    }
}

const fromJson = (item) => {
    return {
        cosoYteTunhanId: item.cosoYteTunhanId,
        ten: item.ten,
        chuCoSo: item.chuCoSo,
        gioiTinh: item.gioiTinh,
        namSinh: item.namSinh,
        trinhdochuyenmonYId: item.trinhdochuyenmonYId,
        chuyenkhoaYId: item.chuyenkhoaYId,
        trinhDoChuyenMonKhac: item.trinhDoChuyenMonKhac,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        loaihinhHanhngheYId: item.loaihinhHanhngheYId,
        soCchn: item.soCchn,
        ngayCapCchn: item. ngayCapCchn,
        soGphd: item.soGphd,
        ngayCapGphd: item.ngayCapGphd,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        cosoYteTunhanId: item.cosoYteTunhanId,
        ten: item.ten,
        chuCoSo: item.chuCoSo,
        gioiTinh: item.gioiTinh,
        namSinh: item.namSinh,
        trinhdochuyenmonYId: item.trinhdochuyenmonYId,
        chuyenkhoaYId: item.chuyenkhoaYId,
        trinhDoChuyenMonKhac: item.trinhDoChuyenMonKhac,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        loaihinhHanhngheYId: item.loaihinhHanhngheYId,
        soCchn: item.soCchn,
        ngayCapCchn: item. ngayCapCchn,
        soGphd: item.soGphd,
        ngayCapGphd: item.ngayCapGphd,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        cosoYteTunhanId: null,
        ten: null,
        chuCoSo: null,
        gioiTinh: null,
        namSinh: null,
        trinhdochuyenmonYId: null,
        chuyenkhoaYId: null,
        loaihinhHanhngheYId: null,
        trinhDoChuyenMonKhac: null,
        phuongXaId: null,
        diaChi: null,
        soCchn: null,
        ngayCapCchn: null,
        soGphd: null,
        ngayCapGphd: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        chuCoSo: null,
        trinhdochuyenmonYId: null,
        trinhDoChuyenMonKhac: null,
        phuongXaId: null,
        loaihinhHanhngheYId: null,
        soCchn: null,
        ngayCapCchn: null,
        soGphd: null,
        ngayCapGphd: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ten: null,
        chuCoSo: null,
        trinhdochuyenmonYId: null,
        trinhDoChuyenMonKhac: null,
        phuongXaId: null,
        loaihinhHanhngheYId: null,
        soCchn: null,
        ngayCapCchn: null,
        soGphd: null,
        ngayCapGphd: null,
        enabled: null,
    }
}

export const coSoYTeTuNhanModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}
